import React from 'react'
import { Col, Row, Label, Input, UncontrolledTooltip, InputGroup, InputGroupText } from 'reactstrap'
import CopyToClipboard from '../../../../Material/CopyToClipboard'
import DatetimeRenderer from "../../../../Material/DatetimeRenderer"

const CustomInputField = ({ label, fieldName, isEditing, isLoading, currentValue, inputValue, onEdit, onSave, onChange, onCancel, inputType = "text", fieldCode = null, showEditIcon = true, showCopyIcon = true, maxValue = null, options = [], displayFormatter = null, renderCustomInput = null, renderEditingModal = null, error = "", fieldDescription = null, customCssClass = "", colSize = null, renderAdditionalActions = null, driverId = null, branchId = null }) => {

    const resolvedValue = inputValue !== undefined && inputValue !== null && inputValue !== "" ? inputValue : currentValue || null
    let inputCssClass = customCssClass ? customCssClass : (resolvedValue === undefined || resolvedValue === null || resolvedValue === "" ? "border border-danger" : "")
    let labelCssClass = resolvedValue === undefined || resolvedValue === null || resolvedValue === "" ? "text-danger" : ""

    return (
        <Col xs={colSize}>
            <Row>
                <Col xs="9">
                    <Label className={labelCssClass}>{label}</Label>
                </Col>
                <Col xs="3" className="text-right align-self-end">
                    {(!isEditing || renderEditingModal) ? (
                        <>
                            {renderAdditionalActions && renderAdditionalActions()}
                            {showEditIcon && <span id={`${fieldName}`}>
                                <i className="fa fa-lg fa-pencil-square cursor-pointer" onClick={() => onEdit(fieldName, currentValue)} title="Edit" />
                            </span>}
                            &nbsp;&nbsp;
                            {showCopyIcon && <CopyToClipboard textToCopy={currentValue || ""} displayText={label} />}
                            {fieldDescription && <>
                                <i className="fa fa-lg fa-info-circle cursor-pointer" id={`info-tooltip-${fieldName}`} />
                                <UncontrolledTooltip target={`info-tooltip-${fieldName}`}>{fieldDescription}</UncontrolledTooltip>
                            </>
                            }
                        </>
                    ) : isLoading ? (
                        <i className="fa fa-lg fa-spinner fa-spin text-muted" title="Saving..." />
                    ) : (
                        <>
                            <i className="fa fa-lg fa-times text-danger cursor-pointer" onClick={onCancel} title="Cancel" />
                            &nbsp;&nbsp;
                            <i className={`fa fa-lg fa-check ${error ? 'text-muted' : 'text-success'} cursor-pointer`} onClick={!error ? () => onSave(fieldName, inputValue) : undefined} title={!error ? "Save" : undefined} style={{ pointerEvents: error ? 'none' : 'auto' }} />
                        </>
                    )}
                </Col>
            </Row>

            {renderEditingModal && renderEditingModal()}

            {isEditing && renderEditingModal ? <Input type="text" disabled value={resolvedValue || ""} className={inputCssClass} />
                : inputType === "select" ? (
                    isEditing ? <Input type="select" name={fieldName} data-field-code={fieldCode} disabled={isLoading} value={resolvedValue} onChange={onChange} style={{ padding: "5px", width: "100%" }} invalid={!!error} className={inputCssClass}>
                        <option value="">Choose {label}</option>
                        {options.map((opt, idx) => <option key={idx} value={opt.value}>{opt.label}</option>)}
                    </Input> : <Input type="text" disabled value={displayFormatter ? displayFormatter(resolvedValue) : options?.find(opt => opt.value === resolvedValue)?.label || ""} className={inputCssClass} />
                ) : (renderCustomInput && isEditing && !isLoading ?
                    renderCustomInput : isEditing ?
                        // Editing Mode: Full input with validation, onChange, and proper input type
                        <Input type={inputType} name={fieldName} data-field-code={fieldCode} disabled={isLoading} value={resolvedValue || ""} max={maxValue} onChange={onChange} invalid={!!error} className={inputCssClass} />
                        :
                        // Display Mode: Use displayFormatter if provided, otherwise preserve original inputType for browser formatting
                        inputType === "datetime-local" ? <InputGroup className="d-block">
                            <InputGroupText style={{ backgroundColor: "#f9f9f9", borderRadius: "7px" }}>
                                <DatetimeRenderer datetime={resolvedValue} driverId={driverId} branchId={branchId} />
                            </InputGroupText>
                        </InputGroup> : <Input type={displayFormatter ? "text" : inputType} disabled value={displayFormatter ? displayFormatter(resolvedValue) : (resolvedValue || "")} className={inputCssClass} />)}

            {error && (
                <div className="text-danger small mt-1">{error}</div>
            )}
        </Col>
    )
}

export default CustomInputField
